module.exports = __webpack_public_path__ + "img/alipay165x58.cf6e229f.png";